import i18n from "config/i18next";

i18n.addResources("es", "governmentalEntity", {
  title: "Ente gubernamental",
  subtitle: "Cargá el archivo maestro de Ente gubernamental que permitirá la validación de facturas.",
  updateFile: "Actualización de archivo",
  versionHistory: "Historial de versiones",
  fileLabel: "Documento entidad gubernamental",
  loadFile: "Cargar",
  actualizar: "Actualizar",
  tooltipInfo:
    "Cuando cargues y confirmes el \narchivo, se sumará la \ninformación a la base de datos.",
  version: "Versión",
  estado: "Estado",
  uploadDate: "Fecha de carga",
  uploadedBy: "Subido por",
  download: "Descargar",
  activa: "Activa",
  noVersions: "No hay versiones previas.",
  loadingVersions: "Cargando versiones...",
  successMessage: "Actualización de Ente gubernamental exitosa.",
  errorMessage: "Error al subir el documento",
  errorDownload: "Error al descargar el archivo",
  invalidFileType: "Formato inválido.",
  fileTooLarge: "El archivo no puede superar los {{max}}MB.",
  fileHelperText: "Tamaño máximo: 4MB. Formato válido: .csv",
  fileReplaceText: "Arrastrá o seleccioná el recuadro para reemplazar el archivo.",
  confirmUpdateTitle: "Revisá los detalles antes de actualizar",
  confirmUpdateMessage:
    "Nombre del archivo cargado: <b style='word-break:break-all'>{{fileName}}</b>\nLa fecha de actualización se registrará al confirmar.",
  confirmDeleteTitle: "Estás por eliminar el archivo",
  confirmDeleteMessage: "¿Realmente querés eliminarlo?",
  errorTitle: "Error al subir el documento",
  errorBodySingle: "El archivo no cuenta con la columna requerida {{missingData}}.",
  errorBody: "El archivo no cuenta con las columnas requeridas {{missingData}}.",
});
